import { AdaptedEntry } from '../AdaptedEntry';

export class CoverDto {
  sumAssured: number;
  startDate: Date;
  endDate: Date;
  variables: Record<string, AdaptedEntry> = {};
}
